import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/item`,
    name: 'MAINTAIN_ITEM_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
